import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

import Image from '@components/Image'

import { H2, H5, H6 } from '@components/Text'

export const Wrapper = styled.section`
  padding-top: 72px;
  padding-bottom: 28px;
  background-color: var(--background-light);

  @media (min-width: ${getBreakpoint('xl')}px) {
    padding-top: 96px;
    padding-bottom: 96px;
    background: linear-gradient(
      0deg,
      var(--white) 51%,
      var(--background-light) 49%
    );
  }
`

export const Title = styled(H2)`
  font-weight: 900;
  line-height: 37px;
  color: var(--primary-text);

  span {
    color: var(--sao-paulo-60);
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    line-height: 48px;
  }
`

export const ListWrapper = styled.section`
  margin-top: 56px;
`

export const Item = styled.section`
  display: flex;
  align-items: center;
  margin-bottom: 72px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 0;
  }
`

export const ItemIcon = styled(Image)`
  width: 85px;
  height: 85px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    width: 142px;
    height: 142px;
  }
`

export const ItemDescription = styled.section`
  display: flex;
  flex-direction: column;
  margin-left: 16px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    align-items: flex-start;
    margin-left: 0;
  }
`

export const ItemTitle = styled(H5)`
  font-weight: 700;
  line-height: 20px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 16px;
    text-align: center;
  }
`

export const ItemSubtitle = styled(H6)`
  font-weight: 400;
  line-height: 24px;
  margin-top: 8px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 16px;
  }
`
